import { Icon } from './Icons';
import { QualityChip } from './QualityChip';
import { QtyControl } from './QtyControl';
import { formatInches } from '../lib/format';

function thumbStyle(name) {
  // Stable hue from filename so the same file always gets the same color.
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % 360;
  return {
    background: `linear-gradient(135deg, oklch(0.55 0.15 ${h}), oklch(0.32 0.08 ${(h + 40) % 360}))`,
  };
}

export function FileRow({ file, onRemove, onQty }) {
  if (file.rejected) {
    const blocks = file.analysis?.blocks || [];
    return (
      <div className="file-row" style={{ borderColor: 'var(--poor)' }}>
        <div className="thumb" style={{ background: 'var(--poor)' }}>
          <Icon.Alert width="20" height="20" style={{ color: 'white' }} />
        </div>
        <div className="fr-meta">
          <div className="fr-name">{file.originalName}</div>
          <div className="fr-sub" style={{ color: 'var(--poor)' }}>
            {blocks.map((b) => b.message).join(' ')}
          </div>
        </div>
        <div className="fr-price"></div>
        <button type="button" className="fr-remove" onClick={() => onRemove(file.fileId)} aria-label="Remove">
          <Icon.X width="16" height="16" />
        </button>
      </div>
    );
  }
  const initials = file.originalName.replace(/\.[^.]+$/, '').slice(0, 2).toUpperCase();
  return (
    <div className="file-row">
      <div className="thumb" style={thumbStyle(file.originalName)}>
        <div className="thumb-stripe" />
        <span className="thumb-initials">{initials}</span>
      </div>
      <div className="fr-meta">
        <div className="fr-line">
          <span className="fr-name">{file.originalName}</span>
          <QualityChip rating={file.dpiRating} />
        </div>
        <div className="fr-line fr-sub">
          <span className="mono">{formatInches(file.width)} × {formatInches(file.length)}</span>
          <span className="dot-sep">·</span>
          <QtyControl value={file.qty} onChange={(v) => onQty(file.fileId, v)} />
        </div>
        {file.warnings?.length > 0 && (
          <div className="fr-line fr-sub" style={{ color: 'var(--fair)' }}>
            {file.warnings.map((w) => w.message).join(' · ')}
          </div>
        )}
      </div>
      <div className="fr-price"></div>
      <button type="button" className="fr-remove" onClick={() => onRemove(file.fileId)} aria-label="Remove">
        <Icon.Trash width="16" height="16" />
      </button>
    </div>
  );
}
